export const ERROR_MESSAGES: { [key: string]: string } = {
  400: '요청이 올바르지 않아요. 입력값을 확인해 주세요.',
  401: '로그인이 필요해요. 로그인 후 다시 시도해 주세요.',
  403: '권한이 없어요. 필요한 권한을 확인해 주세요.',
  404: '찾을 수 없는 페이지예요. 주소를 확인해 주세요.',
  500: '서버에 문제가 생겼어요. 잠시 후 다시 시도해 주세요.',
  invalidFileType: '첨부파일은 pdf만 업로드 가능합니다.',
  default: '알 수 없는 오류가 발생했어요. 다시 시도해 주세요.',
};
